export default import.meta.ROLLDOWN_FILE_URL_Q$UVRrBx1SbqCrj4Xi237g